module.exports = __webpack_public_path__ + "img/app-screenshot_1x.ca28e2e8.png";